"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const geobuf_1 = __importDefault(require("geobuf"));
const pbf_1 = __importDefault(require("pbf"));
const Progressable_1 = require("../../utils/objects/Progressable");
const TrError_1 = __importDefault(require("../../utils/TrError"));
const Status = __importStar(require("../../utils/Status"));
/**
 *
 * @param baseCollection The collection whose features will be updated
 * @param attributesCollection The attributes objects to create the new objects to load as features
 * @param collectionManager TODO Remove?
 * @returns Return the status of the load, either 'success' or 'error'
 */
const loadFromCollection = function (baseCollection, attributesCollection, collectionManager) {
    if ((0, Progressable_1.isProgressable)(baseCollection)) {
        baseCollection.progress('LoadingFromCollection', 0.0);
    }
    const collectionName = baseCollection.displayName;
    if (attributesCollection) {
        try {
            const features = attributesCollection.map((attributes) => baseCollection.newObject(attributes, false, collectionManager));
            baseCollection.setFeatures(features);
            if ((0, Progressable_1.isProgressable)(baseCollection)) {
                baseCollection.progress('LoadingFromCollection', 1.0);
            }
            return {
                status: 'success'
            };
        }
        catch (error) {
            console.error(error);
            return {
                status: 'error',
                error: new TrError_1.default(`cannot load ${collectionName}`, 'CL0001', `${collectionName}CouldNotBeFetchedBecauseDataIsInvalid`)
            };
        }
    }
    else {
        return {
            status: 'error',
            error: new TrError_1.default(`cannot load ${collectionName}`, 'CL0002', `${collectionName}CouldNotBeFetchedBecauseServerError`)
        };
    }
};
/**
 * Load a collection from the server and assign the features to the collection in parameter
 *
 * TODO: Do we need the collectionManager
 * TODO: Make the dataSourceId and socketEventName as optional typed parameter object and see if undefined is enough or we need null
 * @param collection The collection whose features to set
 * @param socket The socket
 * @param collectionManager
 * @param dataSourceId
 * @param socketEventName
 * @returns
 */
const loadFromServer = function (collection, socket, collectionManager, dataSourceId = null, socketEventName = null) {
    return new Promise((resolve, reject) => {
        if ((0, Progressable_1.isProgressable)(collection))
            collection.progress('LoadingFromServer', 0.0);
        const socketPrefix = collection.socketPrefix;
        socket.emit(socketEventName ? socketEventName : `${socketPrefix}.collection`, dataSourceId, (response) => {
            if (response &&
                response.collection &&
                loadFromCollection(collection, response.collection, collectionManager).status === 'success') {
                resolve(response);
            }
            else {
                console.error(`cannot load ${socketPrefix} collection from server`);
                reject(new TrError_1.default(`cannot load ${socketPrefix} collection from server`, 'CL0003', `${socketPrefix}CollectionCouldNotBeFetchedFromServerBecauseServerError`).export());
            }
            if ((0, Progressable_1.isProgressable)(collection)) {
                collection.progress('LoadingFromServer', 1.0);
            }
        });
    });
};
const loadGeojsonFromCollection = function (collection, features) {
    if ((0, Progressable_1.isProgressable)(collection))
        collection.progress('LoadingFromCollection', 0.0);
    const collectionName = collection.displayName;
    if (features) {
        try {
            collection.setFeatures(features);
            if ((0, Progressable_1.isProgressable)(collection)) {
                collection.progress('LoadingFromCollection', 1.0);
            }
            return {
                status: 'success'
            };
        }
        catch (_a) {
            return {
                status: 'error',
                error: new TrError_1.default(`cannot load ${collectionName} geojson`, 'CLG0001', `${collectionName}GeosjonCouldNotBeFetchedBecauseDataIsInvalid`)
            };
        }
    }
    else {
        return {
            status: 'error',
            error: new TrError_1.default(`cannot load ${collectionName} geojson`, 'CLG0002', `${collectionName}GeosjonCouldNotBeFetchedBecauseServerError`)
        };
    }
};
const loadGeojsonFromServer = function (collection, socket, dataSourceIds = [], socketEventName, sampleSize) {
    return new Promise((resolve, reject) => {
        if ((0, Progressable_1.isProgressable)(collection))
            collection.progress('LoadingFromServer', 0.0);
        const socketPrefix = collection.socketPrefix;
        socket.emit(socketEventName ? socketEventName : `${socketPrefix}.geojsonCollection`, { dataSourceIds, sampleSize, format: 'geobuf' }, (responseStatus) => {
            if (Status.isStatusOk(responseStatus)) {
                const geojsonResponse = Status.unwrap(responseStatus);
                const geojson = geojsonResponse.type === 'geobuf'
                    ? geobuf_1.default.decode(new pbf_1.default(geojsonResponse.geobuf))
                    : geojsonResponse.geojson;
                if (geojson &&
                    geojson.features &&
                    loadGeojsonFromCollection(collection, geojson.features).status === 'success') {
                    if ((0, Progressable_1.isProgressable)(collection)) {
                        collection.progress('LoadingFromServer', 1.0);
                    }
                    return resolve(geojson);
                }
            }
            return reject(new TrError_1.default(`cannot load ${socketPrefix} geojson collection from server`, 'CLG0003', `${socketPrefix}GeojsonCollectionCouldNotBeFetchedFromServerBecauseServerError`).export());
        });
    });
};
const loadFromServerByFilter = function (collection, socket, collectionManager, dataSourceId = null, socketEventName = null, filter) {
    return new Promise((resolve, reject) => {
        if ((0, Progressable_1.isProgressable)(collection))
            collection.progress('LoadingFromServer', 0.0);
        const socketPrefix = collection.socketPrefix;
        socket.emit(socketEventName ? socketEventName : `${socketPrefix}.collection`, dataSourceId, filter, (response) => {
            if (response &&
                response.collection &&
                loadFromCollection(collection, response.collection, collectionManager).status === 'success') {
                resolve(response);
            }
            else {
                console.error(`cannot load ${socketPrefix} collection from server`);
                reject(new TrError_1.default(`cannot load ${socketPrefix} collection from server`, 'CL0003', `${socketPrefix}CollectionCouldNotBeFetchedFromServerBecauseServerError`).export());
            }
            if ((0, Progressable_1.isProgressable)(collection)) {
                collection.progress('LoadingFromServer', 1.0);
            }
            return;
        });
    });
};
exports.default = {
    loadFromCollection,
    loadFromServer,
    loadGeojsonFromCollection,
    loadGeojsonFromServer,
    loadFromServerByFilter
};
//# sourceMappingURL=CollectionLoadable.js.map